<template lang="pug">
    footer#mainFooter
        img(:src="require('@images/logo/unifael-ser.png')", alt="Centro Universitário UNIFAEL")
</template>

<script>
export default {
    name: "component-footer"
}
</script>

<style lang="stylus" scoped src="@components/Footer/Footer.styl"></style>